import axios from 'axios'
import shortly from 'vuex-shortly'
import {
  CLIENT, CLIENT_CREATE, CLIENT_PATCH, CLIENT_DELETE, VIDALINK_CLIENTS,
  CLIENT_CLEAR, CLIENTS, CLIENTS_PAGINATE, CLIENTS_IMPORTS, NOTIFICATIONS_INCLUDE
} from '@store/types'
import graphQL from '@graphQL'
import ClientQuery from '@graphQL/queries/Client'
import ClientsQuery from '@graphQL/queries/Clients'
import ClientImports from '@graphQL/queries/Imports'
import fileUpload from '@helpers/fileUpload'

const state = {
  client: {},
  clients: [],
  vidalink_clients: [],
  paginate: {},
  imports: []
}

const getters = {
  [CLIENT]: 'client',
  [CLIENTS]: 'clients',
  [VIDALINK_CLIENTS]: 'vidalink_clients',
  [CLIENTS_PAGINATE]: 'paginate',
  [CLIENTS_IMPORTS]: 'imports'
}

const mutations = {
  [CLIENT]: 'client',
  [CLIENTS]: 'clients',
  [VIDALINK_CLIENTS]: 'vidalink_clients',
  [CLIENTS_PAGINATE]: 'paginate',
  [CLIENTS_IMPORTS]: 'imports'
}

const actions = {
  [CLIENT]: async ({ commit }, payload) => {
    const response = await graphQL(ClientQuery, payload)
    const { company: client } = response.data?.data || {}
    Object.keys(client || {}).forEach((key) => (client[key] == null) && delete client[key])
    commit(CLIENT, client || {})
    return response
  },
  [CLIENTS_IMPORTS]: async ({ commit }, company) => {
    const { data: { data: { imports: { data } } } } = await graphQL(ClientImports, company)

    commit(CLIENTS_IMPORTS, data || {})
  },
  [CLIENT_CREATE]: async ({ commit, dispatch }, payload) => {
    const { contract, ...data } = payload
    const response = await axios.post('/company', data)
    if (response.data.success) {
      const message = 'Cliente criado com sucesso!'
      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message
      })

      const { id } = response.data.data
      const url = `/company/${id}`
      if (contract) {
        fileUpload({ url, contract },
          'Contrato importado com sucesso',
          'Não foi possível importar o contrato'
        )
      }
    } else {
      const message = 'Não foi possível criar o cliente.'
      dispatch(NOTIFICATIONS_INCLUDE, new Error(message))
    }
    return response
  },
  [CLIENT_PATCH]: async ({ commit, state, dispatch }, { id, payload }) => {
    Object.keys(payload).forEach((key) => (payload[key] == null) && delete payload[key])
    const { contract, ...data } = payload
    const url = `/company/${id || state.client.id}`
    const response = await axios.patch(url, data)
    if (response.data.success) {
      const message = 'Cliente alterado com sucesso!'
      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message
      })
    } else {
      const message = 'Não foi possível alterar o cliente.'
      dispatch(NOTIFICATIONS_INCLUDE, new Error(message))
    }

    if (contract) {
      fileUpload({ url, contract },
        'Contrato importado com sucesso',
        'Não foi possível importar o contrato'
      )
    }
    commit(CLIENT, response.data?.data)
    return response
  },
  [CLIENTS]: async ({ commit }, { changed = false, page = 1, ...payload } = {}) => {
    const response = await graphQL(ClientsQuery, { ...payload, page: changed ? 1 : page })
    const { data: clients, ...paginate } = response.data?.data?.companies || {}
    commit(CLIENTS, clients || [])
    commit(CLIENTS_PAGINATE, paginate || {})
  },
  [VIDALINK_CLIENTS]: async ({ commit }) => {
    const response = await graphQL(ClientsQuery, { getDetails: false, limit: 100000, page: 1, vidalink: 'true' })
    const { data: clients } = response.data?.data?.companies || {}
    commit(VIDALINK_CLIENTS, clients || [])
  },
  [CLIENT_CLEAR]: async ({ commit }) => {
    commit(CLIENT, {})
  },
  [CLIENT_DELETE]: async ({ commit }, id) => {
    const response = await axios.delete(`/company/${id}`)
    return response
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/clients.js